import { render, staticRenderFns } from "./ViewSidebar.vue?vue&type=template&id=b03af96c&scoped=true"
import script from "./ViewSidebar.vue?vue&type=script&lang=js"
export * from "./ViewSidebar.vue?vue&type=script&lang=js"
import style0 from "./ViewSidebar.vue?vue&type=style&index=0&id=b03af96c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03af96c",
  null
  
)

export default component.exports